export class ReferenceDataValidationError extends Error {
    field: string;

    constructor(field: string) {
        super(field);
        this.name = 'ReferenceDataValidationError';
        this.field = field;
    }
}
